import React from "react";

export const FormInput = ({
  register,
  error,
  label,
  id,
  isRequired,
  //Texto de ayuda visible debajo del label (para consignas que antes vivían
  //solo en el placeholder y desaparecían al escribir).
  ayuda,
  ...inputProps
}) => {
  const errorId = `${id}-error`;
  const ayudaId = `${id}-ayuda`;
  //aria-describedby apunta a la ayuda y/o al error, según existan.
  const describedBy =
    [ayuda ? ayudaId : null, error ? errorId : null].filter(Boolean).join(" ") ||
    undefined;
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      {ayuda && (
        <small id={ayudaId} className="form-text text-muted mb-1">
          {ayuda}
        </small>
      )}
      <input
        {...register(id, { required: isRequired })}
        //is-invalid pinta el borde rojo de Bootstrap; los aria-* enlazan el
        //campo con su ayuda y su mensaje de error, y marcan si es obligatorio.
        className={`form-control ${error ? "is-invalid" : ""}`}
        id={id}
        aria-required={isRequired || undefined}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        {...inputProps}
      />
      {error && (
        <small id={errorId} className="text-danger form-text">
          {/*Si la validación aportó un mensaje propio (formato de email, DNI,
             etc.) se muestra ese; si no, el genérico de campo obligatorio.*/}
          {error.message || "Campo Obligatorio."}
        </small>
      )}
    </div>
  );
};

export default FormInput;
